(() => {
  if (window.fnCartDrawerInitialized) return;
  window.fnCartDrawerInitialized = true;
  const replaceRenderedCart = (sectionHtml) => {
    if (!sectionHtml) return false;
    const parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
    const nextDrawer = parsed.querySelector('#CartDrawer');
    const currentDrawer = document.querySelector('#CartDrawer');
    if (!nextDrawer || !currentDrawer) return false;
    currentDrawer.replaceWith(nextDrawer);
    const nextCounts = [...parsed.querySelectorAll('[data-cart-count]')];
    document.querySelectorAll('[data-cart-count]').forEach((count, index) => {
      const nextCount = nextCounts[index] || nextCounts[0];
      if (!nextCount) return;
      count.textContent = nextCount.textContent;
      count.hidden = nextCount.hidden;
      const button = count.closest('[data-drawer-open="cart"]');
      if (button) button.setAttribute('aria-label', `Cart, ${nextCount.textContent.trim()} items`);
    });
    return true;
  };


const openDrawer = () => document.querySelector('[data-drawer-open="cart"]')?.click();
  // Keep native cart line keys: one-time and subscription lines may share a variant.
  const updateDrawerCart = async (payload, endpoint = 'change') => {
    const drawer = document.querySelector('#CartDrawer');
    if (!drawer || drawer.getAttribute('aria-busy') === 'true') return;
    const sectionId = drawer.dataset.cartDrawerSection;
    drawer.setAttribute('aria-busy', 'true');
    drawer.querySelectorAll('button, input, select').forEach((control) => { control.disabled = true; });
    const status = drawer.querySelector('[data-cart-drawer-status]');
    if (status) status.textContent = '';
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/${endpoint}.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ ...payload, sections: [sectionId], sections_url: window.location.pathname + window.location.search }),
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Unable to update your cart. Please try again.');
      let html = result.sections?.[sectionId];
      if (!html) {
        const url = new URL(window.location.href);
        url.searchParams.set('sections', sectionId);
        const rendered = await fetch(url).then((r) => r.json());
        html = rendered[sectionId];
      }
      const wasOpen = drawer.classList.contains('is-open');
      const scrollTop = drawer.querySelector('.sb-cart-drawer__items-wrapper')?.scrollTop || 0;
      if (!replaceRenderedCart(html)) throw new Error('Your cart changed. Please reload to see the updated cart.');
      if (wasOpen) {
        openDrawer('cart', document.querySelector('[data-drawer-open="cart"]'));
        const content = document.querySelector('#CartDrawer .sb-cart-drawer__items-wrapper');
        if (content) content.scrollTop = scrollTop;
      }
    } catch (error) {
      if (status) status.textContent = error.message;
    } finally {
      drawer.removeAttribute('aria-busy');
      drawer.querySelectorAll('button, input, select').forEach((control) => { control.disabled = false; });
    }
  };
  document.addEventListener('click', (event) => {
    const step = event.target.closest('[data-fn-cart-step]');
    const remove = event.target.closest('[data-fn-cart-remove]');
    const add = event.target.closest('[data-fn-cart-add]');
    if (add) { event.preventDefault(); updateDrawerCart({ items: [{ id: Number(add.dataset.fnCartAdd), quantity: 1 }] }, 'add'); return; }
    if (!step && !remove) return;
    event.preventDefault();
    const line = (step || remove).closest('[data-fn-cart-line]');
    const input = line.querySelector('[data-fn-cart-quantity]');
    const quantity = remove ? 0 : Math.max(0, (Number(input.value) || 0) + Number(step.dataset.fnCartStep));
    updateDrawerCart({ id: line.dataset.key, quantity });
  });
  document.addEventListener('change', (event) => {
    const control = event.target.closest('[data-fn-cart-quantity], [data-fn-cart-plan]');
    if (!control) return;
    const line = control.closest('[data-fn-cart-line]');
    const quantity = Math.max(0, Math.floor(Number(line.querySelector('[data-fn-cart-quantity]')?.value ?? line.dataset.quantity)));
    if (!Number.isFinite(quantity)) return;
    const payload = { id: line.dataset.key, quantity };
    if (control.matches('[data-fn-cart-plan]')) payload.selling_plan = control.value ? Number(control.value) : null;
    updateDrawerCart(payload);
  });

})();
